import headerImgEn from "assets/images/v128/header-en.webp"
import infoImgEn from "assets/images/v128/info-en.webp"

export const v128ConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
  },
  info: {
    en: infoImgEn,
  },
}
